import { IAppState } from '../app.state';
import { createSelector } from '@ngrx/store';
import { IBeneficiariosState } from '../reducers/beneficiarios.reducers';

export const selectBeneficiariosList = createSelector(
    (state: IAppState) => state.beneficiarios,
    (state: IBeneficiariosState) => state.beneficiarios
);

export const selectEstudioBeneficiario = createSelector(
    (state: IAppState) => state.beneficiarios,
    (state: IBeneficiariosState) => state.estudio
);